export default "__VITE_ASSET__ZOLn9IQb__"